module.exports = __webpack_public_path__ + "static/media/Icon_inicio_trofeo.17662107.png";